import { cn } from "@/lib/utils";

export function HamburgerAnimated({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				"relative size-4 mx-1 text-primary rounded-sm focus:outline-none",
				className,
			)}
		>
			<span className="sr-only">Open main menu</span>
			<div className="absolute block w-4 transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
				<span
					aria-hidden="true"
					className="block absolute h-0.5 w-4 bg-current transform transition duration-500 ease-in-out 
                     -translate-y-1.5 group-hover:rotate-45 group-hover:translate-y-0"
				/>
				<span
					aria-hidden="true"
					className="block absolute h-0.5 w-4 bg-current transform transition duration-500 ease-in-out 
                     opacity-100 group-hover:opacity-0"
				/>
				<span
					aria-hidden="true"
					className="block absolute h-0.5 w-4 bg-current transform transition duration-500 ease-in-out 
                     translate-y-1.5 group-hover:-rotate-45 group-hover:translate-y-0"
				/>
			</div>
		</div>
	);
}
